/*
 * gs-buy-box.js — behavior for blocks/gs-buy-box.liquid.
 *
 * The 4 tier cards are real variants of the product's "Bundle" option (Duo/Starter/Squad/
 * Ultimate Battle). Selecting a tier:
 *  1. Writes the variant id into the form's own hidden input[data-gs-variant-id], so the plain
 *     /cart/add form (intercepted by gs-cart.js) posts the right variant.
 *  2. Updates the sticky-ATC bar's price from the tier's own pre-rendered (Liquid | money)
 *     total, so currency formatting always matches the store's active currency.
 * A tier whose variant doesn't exist yet (data-gs-tier-stub) is disabled and non-interactive —
 * it only shows the STRUCTURE.md reference price until that variant is created.
 *
 * Also owns the sticky-ATC bar's show/hide (IntersectionObserver on the main Add to cart
 * button), matching the competitor's own data-sticky-atc / data-visible / inert pattern.
 */
(function () {
  function initBuyBox(root) {
    if (!root || root.dataset.gsInit === 'true') return;
    root.dataset.gsInit = 'true';

    var form = root.querySelector('[data-gs-bundle]');
    if (!form) return;

    var tiers = Array.prototype.slice.call(root.querySelectorAll('[data-gs-tier]'));
    var variantInput = form.querySelector('[data-gs-variant-id]');
    var stickyPrice = root.querySelector('[data-gs-sticky-price]');

    function selected() {
      var checked = tiers.filter(function (t) {
        var input = t.querySelector('input');
        return input && input.checked;
      })[0];
      if (checked) return checked;
      return tiers.filter(function (t) { return !t.hasAttribute('data-gs-tier-stub'); })[0];
    }

    function render() {
      var tier = selected();
      if (!tier) return;
      tiers.forEach(function (t) { t.classList.toggle('gs-tier--selected', t === tier); });

      var variantId = tier.dataset.variantId;
      if (variantInput && variantId && variantInput.value !== variantId) {
        variantInput.value = variantId;
      }
      if (stickyPrice && tier.dataset.total) {
        stickyPrice.textContent = tier.dataset.total;
      }
      var pre = tier.dataset.preorder === 'true';
      var note = root.querySelector('[data-gs-preorder-note]');
      var prop = root.querySelector('[data-gs-preorder-prop]');
      if (note) note.hidden = !pre;
      if (prop) prop.disabled = !pre;
      root.querySelectorAll('[data-gs-add-button]').forEach(function (btn) {
        var label = pre ? btn.dataset.preorderLabel : btn.dataset.atcLabel;
        if (label) btn.textContent = label;
      });
    }

    tiers.forEach(function (t) {
      if (t.hasAttribute('data-gs-tier-stub')) return;
      var input = t.querySelector('input');
      if (input) input.addEventListener('change', render);
    });

    render();
  }

  function initStickyAtc(root) {
    var bar = root.querySelector('[data-gs-sticky-atc]');
    var mainButton = root.querySelector('[data-gs-add-button]');
    if (!bar || !mainButton || !('IntersectionObserver' in window)) return;

    new IntersectionObserver(function (entries) {
      var entry = entries[0];
      var show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      bar.dataset.visible = String(show);
      if (show) bar.removeAttribute('inert');
      else bar.setAttribute('inert', '');
    }).observe(mainButton);
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-gs-buy-box]').forEach(function (root) {
      initBuyBox(root);
      initStickyAtc(root);
    });
  }

  init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
